import { render } from "./SaveEducation.vue?vue&type=template&id=20f3790e"
import script from "./SaveEducation.vue?vue&type=script&lang=js"
export * from "./SaveEducation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__